import { TeamDistributionMethod } from "./evaluation-phase";

export class AssignmentModel {
  ApplicationId: string;
  TeamId: string;
  UserIds: string[];
  TeamDistributionMethod: TeamDistributionMethod;
}
